import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../constants/storage-keys';

@Injectable({
  providedIn: 'root',
})
export class CoreStorageService {
  setItem<T>(key: string, value: T): void {
    try {
      const payload = JSON.stringify(value);
      localStorage.setItem(key, payload);
    } catch (err) {
      console.error('CoreStorageService.setItem error', err);
    }
  }

  getItem<T>(key: string): T | string | null {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return null;
      try {
        return JSON.parse(raw) as T;
      } catch (e) {
        // Not JSON, return raw
        return raw;
      }
    } catch (err) {
      console.error('CoreStorageService.getItem error', err);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error('CoreStorageService.removeItem error', err);
    }
  }

  clearAppKeys(): void {
    try {
      Object.values(STORAGE_KEYS).forEach((k) => localStorage.removeItem(k));
    } catch (err) {
      console.error('CoreStorageService.clearAppKeys error', err);
    }
  }

  // Convenience helpers
  setBoolean(key: string, value: boolean): void {
    this.setItem(key, value);
  }

  getBoolean(key: string): boolean | null {
    const v = this.getItem<any>(key);
    if (v === null) return null;
    return typeof v === 'boolean' ? v : v === 'true';
  }

  setNumber(key: string, value: number): void {
    this.setItem(key, value);
  }

  getNumber(key: string): number | null {
    const v = this.getItem<any>(key);
    if (v === null) return null;
    return typeof v === 'number' ? v : Number(v);
  }
}
